import React, { useState } from 'react'
import { Modal, Button } from '@byscott-io/corebyscott'
import Lex from '../Shared/Lex'

// Delegates to corebyscott's shared <Modal> (subtle backdrop, draggable header
// provided natively — the old ~90-line manual drag hack was removed). Rendered
// inside `.cbs-scope` so core's Tailwind utilities apply during the Bootstrap→
// Tailwind migration (#635). Keeps the { modalData, modalActions } call-site API.
const ModalForm = ({ modalActions, modalData }) => {
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null)

  const close = (cb) => {
    setError(null)
    modalActions.closeModal(cb)
  }

  const save = () => {
    if (modalData?.saveClick) { return modalData.saveClick() }
    if (modalData?.formRecord && modalData?.formSource?.saveRecord) { if (modalData.formSource.saveRecord(modalData.formRecord)) close() }
  }

  const formFields = () => {
    if (modalData?.formFields) { return modalData.formFields }
    if (modalData?.formRecord && modalData?.formSource?.formFields) { return modalData.formSource.formFields(modalData.formRecord) }
  }

  const formButtons = () => {
    if (modalData?.formButtons) { return modalData.formButtons } else {
      return (
        <div className="flex gap-3">
          <Button data-cy="modal-cancel-button" onClick={() => close()} color="default"><Lex term="cancel" /></Button>
          <Button data-cy="modal-save-button" onClick={() => save()} color="success"><Lex term="save" /></Button>
        </div>)
    }
  }

  return (
    <div className="cbs-scope">
      <Modal
        open={modalData?.name === 'ModalForm'}
        onClose={() => close()}
        title={modalData?.formName}
        footer={modalData?.disableFormButtons ? undefined : formButtons()}
      >
        {formFields()}
      </Modal>
    </div>
  )
}

export default ModalForm
